// extracted by mini-css-extract-plugin
export default {"banner":"xzFDSZ","header":"VfFsuE","chickpeaBackground":"CPE59Y"};